module.exports = __webpack_public_path__ + "static/img/A61802_2.559a5f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61802_2.png
// module id = QEGn
// module chunks = 1